module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1 && _vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', {
    staticClass: "content-bottom-padded",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 5,
      "lg": 5
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addElement
    }
  }, [_vm._v("活动添加")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 5,
      "lg": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "标题"
    },
    model: {
      value: (_vm.params.field_title),
      callback: function($$v) {
        _vm.$set(_vm.params, "field_title", $$v)
      },
      expression: "params.field_title"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.searchData
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 5,
      "lg": 5
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "状态"
    },
    on: {
      "change": _vm.searchData
    },
    model: {
      value: (_vm.params.status),
      callback: function($$v) {
        _vm.$set(_vm.params, "status", $$v)
      },
      expression: "params.status"
    }
  }, [_c('el-option', {
    key: "waiting",
    attrs: {
      "label": "未开始",
      "value": "waiting"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "ongoing",
    attrs: {
      "label": "进行中",
      "value": "ongoing"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "end",
    attrs: {
      "label": "已结束",
      "value": "end"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 5,
      "lg": 5
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "value-format": "yyyy/MM/dd",
      "placeholder": "根据添加时间筛选",
      "size": "mini"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.create_time),
      callback: function($$v) {
        _vm.create_time = $$v
      },
      expression: "create_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.ItemsList,
      "height": _vm.wheight - 200
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "activity_id",
      "label": "编号",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "activity_name",
      "label": "活动名称",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "start_time",
      "label": "活动有效期",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.start_date) + " ~ " + _vm._s(scope.row.end_date) + "\n        ")]
      }
    }], null, false, 2973474081)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_join_num",
      "label": "报名人数",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.total_join_num || 0) + "\n        ")]
      }
    }], null, false, 4199351323)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          staticClass: "iconfont icon-edit1",
          attrs: {
            "to": {
              path: _vm.matchHidePage('editor'),
              query: {
                id: scope.row.activity_id
              }
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "iconfont icon-search-plus",
          on: {
            "click": function($event) {
              return _vm.preview(scope.$index, scope.row)
            }
          }
        }), _vm._v(" "), (scope.row.status == 1) ? _c('i', {
          staticClass: "mark iconfont icon-trash-alt1",
          on: {
            "click": function($event) {
              return _vm.deleteAction(scope.$index, scope.row)
            }
          }
        }) : _vm._e()]
      }
    }], null, false, 3662221670)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "dataInfo",
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "200px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.dataInfo.field_title
    }
  }, [(_vm.dataInfo.form_element == 'text') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "text预览"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'textarea') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "textarea预览"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'number') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input-number', {
    attrs: {
      "type": "textarea",
      "placeholder": "55.55"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'image') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "show-file-list": false
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'radio') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-radio-group', _vm._l((_vm.dataInfo.options), function(item, index) {
    return _c('el-radio', {
      key: index,
      attrs: {
        "label": 3
      }
    }, [_vm._v(_vm._s(item.value))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'checkbox') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-checkbox-group', _vm._l((_vm.dataInfo.options), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      attrs: {
        "label": "item.value"
      }
    }, [_vm._v(_vm._s(item.value))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'select') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    }
  }, _vm._l((_vm.dataInfo.options), function(item, key) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'date') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'time') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-time-picker', {
    attrs: {
      "arrow-control": "",
      "picker-options": {
        selectableRange: '18:30:00 - 20:30:00'
      },
      "placeholder": "任意时间点"
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.dataInfo.form_element == 'area') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.options,
      "props": {
        expandTrigger: 'hover'
      }
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-153b52a0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-153b52a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/selfservice/registrationactivity.vue
// module id = 2490
// module chunks = 0